export default __webpack_public_path__ + "static/media/dns-spiral@2x.99b916eb.png";